"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _style = require("webmotors-react-pj/frame/modal/store/list/style");
var _item = _interopRequireDefault(require("webmotors-react-pj/frame/modal/store/item"));
var _radio = _interopRequireDefault(require("webmotors-react-pj/webinput/radio"));
var _lang = _interopRequireDefault(require("webmotors-react-pj/i18n/lang"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = _ref => {
  let {
    data,
    setSelectedStore,
    selectedStore
  } = _ref;
  return _react.default.createElement(_style.StyleContainer, null, _react.default.createElement(_style.StyleAllStore, null, _react.default.createElement(_radio.default, {
    placeholder: _lang.default.header.allStores,
    name: "storeRadio",
    checked: !(selectedStore !== null && selectedStore !== void 0 && selectedStore.id),
    value: {},
    onChange: () => setSelectedStore({})
  })), data.map((item, i) => item && _react.default.createElement(_react.Fragment, {
    key: "list-".concat(i)
  }, item.title && _react.default.createElement(_style.StyleTitle, null, item.title), _react.default.createElement("ul", null, item.items.map(list => {
    const {
      nomeFantasia,
      idLoja
    } = list;
    return _react.default.createElement(_item.default, {
      key: idLoja,
      id: idLoja,
      label: nomeFantasia,
      selectedStore: selectedStore,
      setSelectedStore: setSelectedStore
    });
  })))));
};
exports.default = _default;